// extracted by mini-css-extract-plugin
export default {"modelSlider":"ModelSlider_modelSlider__gf5QM","modelCard":"ModelSlider_modelCard__LzijV","modelImage":"ModelSlider_modelImage__3wo9z","modelName":"ModelSlider_modelName__bRQec"};